export enum DonationType {
  oneOff = 'one-off',
  recurring = 'recurring'
}
